import * as TK from 'pages/ResetPasswordPage/translations/constants';
import { Translations } from 'translations/types';

export const resetPasswordPageEnUsLocale: Translations = {
  [TK.RESET_PASSWORD_PAGE_TITLE]: 'Reset password',
  [TK.RESET_PASSWORD_PAGE_DESCRIPTION]: 'Your password must be different from previous password.',
  [TK.RESET_PASSWORD_PAGE_ICON_ALT]: 'Reset password icon',
};
